import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateVenderEntity } from '../../domain/entities/CreateUpdateVenderEntity'
export class CreateUpdateVenderModel extends CreateUpdateVenderEntity {
  image!: { bytes: string; fileName: string }
  translations = []
  constructor(dataDto: CreateUpdateVenderEntity) {
    super()
    mapEntityProperties<CreateUpdateVenderModel>(this, dataDto, {
      exclude: ['imageData'],
      map: {
        image: dataDto.imageData
      }
    })
  }
}
